import React from 'react';
import { X } from 'lucide-react';

export default function AddToCartModal({ isOpen, onClose, item, cartTotal, onViewCart, onCheckout }) {
  if (!isOpen || !item) return null;

  return (
    <>
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-black bg-opacity-50 z-40 transition-opacity"
        onClick={onClose}
      />
      
      {/* Modal */}
      <div className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-50 w-full max-w-lg px-4">
        <div className="bg-white rounded-lg shadow-xl w-full max-h-[85vh] overflow-y-auto">
          
          {/* Header */}
          <div className="relative border-b border-gray-200 p-4 sm:p-6">
            <button 
              onClick={onClose}
              className="absolute top-3 right-3 sm:top-4 sm:right-4 text-gray-400 hover:text-gray-600 transition-colors"
            >
              <X className="w-5 h-5 sm:w-6 sm:h-6" />
            </button>
            <p className="text-center text-gray-700 text-base sm:text-lg pr-8">
              1 new item has been added to your cart
            </p>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-2 sm:gap-3 px-4 sm:px-6 py-3 sm:py-4 border-b border-gray-200">
            <button
              onClick={onClose}
              className="bg-red-400 hover:bg-red-500 text-white px-5 sm:px-6 py-2.5 sm:py-2 rounded font-medium transition-colors text-sm sm:text-base"
            >
              Continue Shopping
            </button>
            <button
              onClick={onViewCart}
              className="bg-red-400 hover:bg-red-500 text-white px-5 sm:px-6 py-2.5 sm:py-2 rounded font-medium transition-colors text-sm sm:text-base"
            >
              View cart
            </button>
          </div>

          {/* Item Details */}
          <div className="p-4 sm:p-6">
            <div className="flex items-start gap-3 sm:gap-4">
              <img 
                src={item.image} 
                alt={item.name}
                className="w-16 h-16 sm:w-20 sm:h-20 object-cover rounded bg-gray-200 flex-shrink-0"
              />
              <div className="flex-1 min-w-0">
                <h3 className="text-gray-800 font-medium text-sm sm:text-base">{item.name}</h3>
                {item.size && (
                  <p className="text-gray-600 text-xs sm:text-sm mt-1">Size: {item.size}</p>
                )}
              </div>
              <div className="text-right flex-shrink-0">
                <p className="text-gray-600 text-xs sm:text-sm">Qty: {item.quantity}</p>
                <p className="text-gray-800 font-semibold mt-1 text-sm sm:text-base">
                  ${cartTotal.toFixed(2)}
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </>
  );
}